import React, { useState } from 'react';
import SwipeableViews from 'react-swipeable-views';
import Main from './Main';
// import Detail from './Detail';
// import Person from './Person';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import uPerson from './usePerson';
import ReactSVG from 'react-svg';
import useTheme from '../hooks/useTheme';
import intl from 'react-intl-universal';
import {alpha} from '../../utils/color';
import asyncComponent from '../AsyncComponent';
import BottomModal from '../ButtonGroup/BottomModal';
import {pushHistory, popHistory} from '../../utils/history';
import './AllForFollowee.scss';
import './Main.scss';

const FolloweeMain = asyncComponent(()=>import('./Main'));
const AllForMyHistory = asyncComponent(()=>import('../Me/AllForMyHistory'));
const AllForMySplice = asyncComponent(()=>import('../Me/AllForMySplice'));
const AllForMyFav = asyncComponent(()=>import('../Me/AllForMyFav'));
const AllForMyPayed = asyncComponent(()=>import('../Me/AllForMyPayed'));

interface IPageFollowee {
  rootStore?: RootStore;
}

interface IPhotoTab {
  icon:any,
  name:string,
  type:string
}

const AllForFollowee = function(props: IPageFollowee) {

  const theme = useTheme();

  const tabs = ([
    {
      icon:require('../../svg/v2/gallery_history.svg'),
      name:intl.get('GalleryHistory'),
      type:'gallery_history'
    },
    {
      icon:require('../../svg/v2/gallery_poster.svg'),
      name:intl.get('SplicePoster'),
      type:'splice_poster'
    },
    {
      icon:require('../../svg/v2/image_like.svg'),
      name:intl.get('FavPhoto'),
      type:'fav_photo'
    },
    {
      icon:require('../../svg/v2/image_payed.svg'),
      name:intl.get('PayedPhoto'),
      type:'payed_photo'
    }
  ] as IPhotoTab[]).filter(Boolean);

  const [currentTab, setCurrentTab] = useState(null as IPhotoTab|null);
  const onTabClick = (tab:IPhotoTab)=>{
    setCurrentTab(tab);

    pushHistory(tab.type, ()=>{
      onTabHide();
    });
  };

  const renderTab = ()=>{
    if(currentTab) {
      const {type} = currentTab;
      if(type == 'gallery_history') {
        return <AllForMyHistory />
      }
      if(type == 'splice_poster') {
        return <AllForMySplice />;
      }
      if(type == 'fav_photo') {
        return <AllForMyFav />;
      }
      if(type == 'payed_photo') {
        return <AllForMyPayed />;
      }
    }
    return null;
  };

  const onTabShow = ()=>{

  };

  const onTabHide = ()=>{
    setCurrentTab(null);
  };

  const {configDetail} = window;

  return (
    <div className="all-for-followee">
      <div className="followee-wrapper">
        <div className="followee-tabs" style={{"boxShadow":`0 2px 4px 2px ${alpha(theme.h1Color, 0.1)}`}}>
          {tabs.map((it,index:number)=>{
            return <div className="followee-tab" key={index} onClick={()=>onTabClick(it)}>
              <ReactSVG
                src={it.icon}
                className="tab-icon"
                style={{ color: theme.mainColor, fill: theme.mainColor }}
              />
              <div className="tab-name" style={{color: theme.h1Color}}>
                {it.name}
              </div>
            </div>;
          })}
        </div>
        <div className="followee-list-wrapper">
          {configDetail && !!+configDetail.use_face && Number(configDetail.active_on) ? <FolloweeMain /> : <div className="followee-list">
            <div className="followee-list-header">
              <div className="followee-list-title">关注的人</div>
            </div>
            <div className="followee-list-content">
              <div className="followee-list-content-empty" style={{color:theme.h2Color}}>
                {intl.get(`No friends`)}
              </div>
            </div>
          </div>}
        </div>
      </div>
      {currentTab ? <BottomModal
        title={currentTab.name}
        simpleTitle={true}
        child={renderTab()}
        show={!!currentTab}
        onHide={()=>{
          popHistory();
          onTabHide();
        }}
      /> : null}
    </div>
  );
};

export default inject('rootStore')(observer(AllForFollowee));
